var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25912 1C5.10117 1 3.33598 2.76645 3.33598 4.9244C3.33598 6.24389 3.99791 7.41236 5.00422 8.12325C2.66173 9.06233 1.0002 11.3534 1.0002 14.0261C0.981503 14.8686 2.255 14.8686 2.2363 14.0261C2.2363 11.1892 4.52365 8.90305 7.36052 8.90305C8.35079 8.90305 9.27 9.18529 10.0524 9.66953C10.7557 10.1009 11.4028 9.04591 10.6994 8.61455C10.3472 8.39661 9.96545 8.22664 9.57197 8.07976C10.5434 7.36523 11.1786 6.21766 11.1786 4.9244C11.1786 2.76645 9.41708 1 7.25912 1ZM7.25912 2.23732C8.74904 2.23732 9.94255 3.43448 9.94255 4.9244C9.94255 6.41432 8.74904 7.60656 7.25912 7.60656C5.76921 7.60656 4.57207 6.41432 4.57207 4.9244C4.57207 3.43448 5.76921 2.23732 7.25912 2.23732ZM11.9651 13.1594V14.3955C11.983 15.2015 13.1833 15.2015 13.2012 14.3955V13.1594H14.4385C15.2633 13.1594 15.2633 11.9222 14.4385 11.9222H13.2012V10.6861C13.2052 10.3395 12.9236 10.0573 12.5771 10.0607C12.2353 10.0631 11.9611 10.3443 11.9651 10.6861V11.9222H10.6994C9.84498 11.9616 9.90413 13.1988 10.729 13.1594H11.9651Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowIcon);
export default __webpack_public_path__ + "static/media/FollowIcon.42129b7e83a6fc2da1e23c48d25bfaf1.svg";
export { ForwardRef as ReactComponent };